// extracted by mini-css-extract-plugin
export const travelGuide = "TravelGuide-module--travel-guide--3r1eA";
export const title = "TravelGuide-module--title--2pX3C";
export const section = "TravelGuide-module--section--n5paE";
export const imgContainer = "TravelGuide-module--img-container--S9Tx9";
export const imgContainerWrapper = "TravelGuide-module--img-container-wrapper--wuXRq";
export const content = "TravelGuide-module--content--3gqqW";
export const subtitle = "TravelGuide-module--subtitle--2-AEv";
export const paragraph = "TravelGuide-module--paragraph--3ay5o";
export const footer = "TravelGuide-module--footer--Fowt_";